module.exports = __webpack_public_path__ + "img/laos.0322ae2.webp";